import { SLOT_TYPES, SOURCES } from "@/config/layoutConfig";
import useLayoutSlots from "@/composables/layoutSlots";

export default function useCameraMap() {
  const { setSlotData } = useLayoutSlots();

  const actions = (item) => {
    switch (item.tag) {
      case "camera-map":
        setSlotData(
          SLOT_TYPES.CAMERA_LOCATION_MAP,
          item.data.name || `CAM_${item.data.camera_proxy_id}`,
          item.data,
          SOURCES.SUBSYSTEM_TREE
        );
        break;
    }
  };

  return { actions };
}
